import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация прод сервера, он же "бой", боевой
 */
export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = true;
  serverPicturesPath = 'https://demodata.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://demodata.compo-soft.ru/documents';
  serverApi = 'https://demodata.compo-soft.ru/api/v1';
  serverUrl = 'https://demodata.compo-soft.ru';
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  impersonatePortalPath = 'https://demo.compo-soft.ru/';
  accessRolesCatalog = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  damNewPermissions = false;
  damChangeLog = true;
  // Включить меню и функционал витрины в админке
  publicShowcase = true;
  // URL витрины
  publicShowcaseUrl = 'https://showcase.compo-soft.ru';
  aiTranslation = true;
  completenessEnabled = true;
  templateDefaultsEnabled = true;
  imageValidator = true;
  xmlImport = true;
  contentLocales = ['ru', 'en', 'kk'];
  commonFeatureGroup = true;
}

export const environment = new EnvironmentAdminProd();
